import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  baseURL = environment.baseURL;

  constructor(private http: HttpClient) {}

  get<T>(url: any, params?: any): Observable<T> {
    return this.http.get<T>(`${this.baseURL}/${url}`, { params });
  }

  post<T>(url: any, data: any, params?: any): Observable<T> {
    return this.http.post<T>(`${this.baseURL}/${url}`, data, { params });
  }

  put<T>(url: any, data: any): Observable<T> {
    return this.http.put<T>(`${this.baseURL}/${url}`, data);
  }

  delete<T>(url: string, token?: any): Observable<T> {
    let headers = new HttpHeaders();

    // Add the token to the headers if it is provided
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    const options = {
      headers: headers,
    };
    return this.http.delete<T>(`${this.baseURL}/${url}`, options);
  }
}
